export default class {
    constructor() {
        this.schema = "iglu:ca.lapresse/context_web_search/jsonschema/1-0-0";
    }
}
